import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import { CheckLine, MainButton } from '@bizzabo/design-system';

import LoaderSpinner from '../LoaderSpinner';

interface LoaderButtonArgs extends React.ComponentProps<typeof MainButton> {
    isLoading?: boolean;
    isSubmitSuccesful?: boolean;
}

const SaveButton: React.FC<LoaderButtonArgs> = ({
    isLoading,
    isSubmitSuccesful,
    className,
    disabled,
    ...otherProps
}) => {
    const classes = useStyles();

    const [successAnimation, setSuccessAnimation] = useState(false);
    const [fadeAnimation, setFadeAnimation] = useState(false);

    useEffect(() => {
        if (!isLoading && isSubmitSuccesful) {
            doSuccessAnimation();
        }
    }, [isLoading]);

    const doSuccessAnimation = () => {
        setSuccessAnimation(true);
        setTimeout(() => {
            setFadeAnimation(true);
            setTimeout(() => {
                setSuccessAnimation(false);
                setFadeAnimation(false);
            }, 450);
        }, 750);
    };

    return (
        <MainButton
            className={cn(className, classes.button)}
            disabled={disabled || isLoading || successAnimation}
            {...otherProps}
        >
            {isLoading && <LoaderSpinner className={classes.icon} />}
            {successAnimation && (
                <CheckLine className={cn(classes.icon, fadeAnimation && classes.iconFade)} />
            )}
            {successAnimation ? 'Saved' : 'Save'}
        </MainButton>
    );
};

const useStyles = makeStyles(
    () => ({
        button: {
            position: 'relative',
            '& > div': {
                paddingTop: 4,
                paddingBottom: 6,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
        },
        icon: {
            height: 20,
            fontSize: 20,
            marginRight: 10,
        },
        iconFade: {
            opacity: 0,
            transition: 'all 450ms linear',
        },
    }),
    { classNamePrefix: 'people-save-button' }
);

export default SaveButton;
